export enum HereditaryDiseaseDefaultEnum {
  CANCER = 'Cáncer',
  OBESITY = 'Obesidad',
  HYPERTENSION = 'Hipertensión',
  MELLITUS_DIABETES = 'Diabetes mellitus'
}
